import { Link, useRouterState } from "@tanstack/react-router";
import { useLingui } from "@lingui/react/macro";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";

export function OrgTabNav() {
  const { t } = useLingui();
  const { location } = useRouterState();
  const pathname = location.pathname;
  const { hasPermission, user } = useAuth();

  // Hide the entire tab nav when the user has no active org context
  // (e.g. super-admin viewing the platform without "logging in as" an org).
  if (user?.organization?.id == null) return null;

  const cls = (to: string) =>
    cn(
      "px-4 pb-3 pt-1 text-sm font-medium transition-colors border-b-2 -mb-px",
      pathname === to || pathname.startsWith(`${to}/`)
        ? "border-(--brand-black) text-(--color-text-primary)"
        : "border-transparent text-(--color-text-secondary) hover:text-(--color-text-primary)",
    );

  return (
    <div className="flex gap-0 border-b border-(--color-border)">
      <Link
        to="/companies"
        search={{ page: 1, pageSize: 50, status: "all" }}
        className={cls("/companies")}
      >
        {t`Concepts`}
      </Link>
      <Link
        to="/users"
        search={{ page: 1, pageSize: 50, status: "all" }}
        className={cls("/users")}
      >
        {t`Users`}
      </Link>
      <Link
        to="/regions"
        search={{ page: 1, pageSize: 50 }}
        className={cls("/regions")}
      >
        {t`Regions`}
      </Link>
      <Link
        to="/locations"
        search={{ page: 1, pageSize: 50, status: "all" }}
        className={cls("/locations")}
      >
        {t`Locations`}
      </Link>
      {hasPermission("role:read") && (
        <Link to="/roles" className={cls("/roles")}>
          {t`Roles`}
        </Link>
      )}
    </div>
  );
}
